var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ArrowLeftSvg from './arrow-left.icon.svg';
export const ArrowLeftIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ArrowLeftSvg }));
_react_refresh_temp_1 = ArrowLeftIcon;
$RefreshReg$(_react_refresh_temp_1, "ArrowLeftIcon");
